export default "__VITE_ASSET__a46beabe__"